import { useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { loadActualities, loadOrders, loadSpecies } from '../utilities/httpRequest';
import Actu from '../components/Actu';
import ResultLabel from '../components/ResultLabel';
import {UAParser} from "ua-parser-js";

export default function HomeContent() {

  const navigate = useNavigate();

  const [news, setNews] = useState([]);
  const [species, setSpecies] = useState([]);

  const [orders, setOrders] = useState({
    count: 0,
    next: null,
    previous: null,
    results: []
  });

  const orderParam = useMemo(() => ({
    page: 1,
    per_page: 6,
    isPrescriber: true
  }), []);

  useEffect(() => { loadActualities(navigate, setNews) }, [navigate]);
  useEffect(() => { loadSpecies(setSpecies, navigate) }, [navigate]);
  useEffect(() => { loadOrders(navigate, setOrders, orderParam) }, [navigate, orderParam]);


  const token = Cookies.get('jwtuser')
  //Logging information
  useEffect(() => {
    // Initialisation du parser
    const parser = new UAParser();
    const browserInfo = parser.getBrowser();
    const osInfo = parser.getOS();

    const userInfo = {
      browserName:browserInfo.name || "Unknown",
      browserVersion:browserInfo.version || "Unknown",
      osName:osInfo.name || "Unknown",
      osVersion:osInfo.version || "Unknown"
    }

    // Envoi API
    const xhttp = new XMLHttpRequest();
    xhttp.open("POST", process.env.REACT_APP_API_URL + "log");
    xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhttp.setRequestHeader("Authorization", "Token " + token);
    xhttp.send(JSON.stringify({
      content: JSON.stringify(userInfo)
    }));

  }, [token])



  return (
    <div className="p-3 flex flex-col gap-5">
      <div>
        <h1 className={news.length ? "" : "hidden"}>Actualités</h1>
        {news.map((actu) => <Actu key={actu.id} actu={actu} />)}
      </div>
      <div>
        <h1 className={orders.count > 0 ? "mb-2" : "hidden"}>Dernières demandes</h1>
          <div className={orders.results.length === 0 ? "disable" : "flex flex-row flex-wrap bg-light-green rounded-2xl p-3 gap-3"}>
            <div className="grow flex flex-col gap-3">
              {orders.results.slice(0, 3).map((order) => <ResultLabel key={order.id} order={order} species={species} />)}
            </div>
            <div className={orders.count>3?"grow flex flex-col gap-3":"hidden"}>
              {orders.results.slice(3, 6).map((order) => <ResultLabel key={order.id} order={order} species={species} />)}
            </div>
          </div>
      </div>
    </div>
  );
}



